import moment from 'moment';
import React, { useState } from 'react';
import { FaRegTrashAlt, FaWhatsapp, FaPhone, FaRegCommentDots, FaMicrophone } from 'react-icons/fa';
import { Virtuoso } from 'react-virtuoso';
import * as Utils from "../utils";

export type RecentChat = {
  id: string
  distributor: string
  sender: 'user' | 'llm'
  text: string
  createdAt: string,
  mode: 'whatsapp' | 'callvoice' | 'webchat' | 'webvoice',
  agent: string | null
}

const ModeIcon = ({ mode }: { mode: string }) => {
  switch (mode) {
    case 'whatsapp':
      return <FaWhatsapp className="mr-2 text-green-500" />;
    case 'callvoice':
      return <FaPhone className="mr-2 rotate-90 text-orange-500" />;
    case 'webvoice':
      return <FaMicrophone className="mr-2 text-purple-500" />;
    case 'webchat':
    default:
      return <FaRegCommentDots className="mr-2 text-blue-500" />;
  }
};

const RecentChats = ({
  recents,
  handleDistributorChange,
  handleClearRecent
}: {
  recents: Array<RecentChat>
  handleDistributorChange: (distributor: string) => Promise<void>
  handleClearRecent: (distributor: string) => Promise<void>
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredRecents = recents.filter(chat =>
    chat.distributor.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="bg-white p-4 rounded-lg shadow-md flex flex-col h-full">
      <h3 className="text-lg font-semibold border-b pb-2 mb-4">Recent Tickets</h3>
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search by dealer..."
          className="w-full p-2 border rounded"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="min-h-0 flex-1">
        <Virtuoso
          className="h-full pr-2"
          data={filteredRecents}
          computeItemKey={(_index, chat) => chat.id || `${chat.distributor}-${chat.createdAt}`}
          components={{
            Footer: () => <div className="h-4" />,
          }}
          itemContent={(_index, chat) => (
            <div className="py-2">
              <div className="flex items-center rounded-lg p-2 hover:bg-gray-100 cursor-pointer">
              <div className="flex-grow" onClick={() => handleDistributorChange(chat.distributor)}>
                <div className="flex items-center">
                  <ModeIcon mode={chat.mode} />
                  <h4 className="font-semibold text-sm">{Utils.formattedName(chat.distributor)}</h4>
                </div>
                <div className="text-xs text-gray-600">
                  <span className="font-medium">{chat.sender === 'user' ? 'You' : 'Berger AI'}:</span> {chat.text.substring(0, 50) + (chat.text.length > 50 ? '...' : '')}
                </div>
                <div className="text-xs text-gray-400 mt-1">{moment(chat.createdAt).format('lll')}</div>
                {chat.agent && <div className="text-xs text-gray-400 mt-1">Agent: {chat.agent}</div>}
              </div>
              <div className="ml-2"
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Clear Ticket">
                <FaRegTrashAlt
                  className="text-gray-500 hover:text-red-500"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClearRecent(chat.distributor);
                  }}
                />
              </div>
              </div>
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default RecentChats;
